module.exports = __webpack_public_path__ + "img/kosovo.b66aec01.png";